import { Component, isDevMode } from '@angular/core';
import { AuthService } from './services/auth.service';
import { jwtDecode } from 'jwt-decode';
import { UtilsService } from './services/utils.service';
import packageInfo from '../../package.json';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false,
})
export class AppComponent {
  authToken;
  jwtDecoded;
  flLogin = true;
  appVersion = packageInfo.version;

  constructor(
    private authService: AuthService,
    public utilsService: UtilsService
  ) {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    this.authToken = urlParams.get('AUTHTOKEN');

    if(this.authService.isAuthenticated) {
      this.authService.login();
      return;
    }

    if(this.authToken === null) {

      // if(isDevMode()) {
      //   this.authService.login();
      //   return;
      // }

      this.authService.logout();
      return;
    }


    try{
      this.jwtDecoded = jwtDecode(this.authToken);
    }
    catch(Error){
        this.jwtDecoded = null;
    }

    if(this.jwtDecoded === null)
    {
      this.authService.logout();
      return;
    }

    this.authService.login();
  }

  checkLogin() {

  }
}
